import { useState } from 'react';
import type { CountdownRenderProps } from 'react-countdown';
import Countdown from 'react-countdown';

import classNames from 'classnames';

import ImageProxy from '@next-image-proxy';

import { ModalHeading } from '@uikit';

import { beforeVoteImage } from '@shared/assets/images/scope/projectValidation';

interface BeforeVoteStepProps {
  onNext: () => void;
  appLink: string;
}

const requirements = [
  'Thoroughly review the project page.',
  'Conduct your own independent research.',
  'Make an informed decision based on the above.',
];

const BeforeVoteStep = ({ onNext, appLink }: BeforeVoteStepProps) => {
  const [countdownDate, setCountdownDate] = useState<number>(-1);

  const handleActionButtonClick = () => {
    if (countdownDate === -1) {
      setCountdownDate(Date.now() + 10000);
    }
  };

  const handleCountdownComplete = () => {
    setCountdownDate(0);

    onNext();
  };

  return (
    <>
      <ImageProxy
        className="h-[138px] w-auto mx-auto"
        src={beforeVoteImage}
        alt=""
        width={335}
        height={272}
      />

      <ModalHeading>
        Before casting your vote, please ensure you&apos;ve done the following:
      </ModalHeading>

      <ul className="bg-primary-100 rounded-2xl p-6 gap-2 flex flex-col font-medium text-secondary">
        {requirements.map((requirement, i) => {
          return (
            <li key={i} className="flex gap-2 items-center">
              <span className="w-6 flex-shrink-0 h-6 border border-secondary rounded-full flex items-center justify-center">
                {i + 1}
              </span>
              {requirement}
            </li>
          );
        })}
      </ul>

      <div className="flex flex-col gap-4 mt-4">
        <a
          href={appLink}
          target="_blank"
          rel="noreferrer"
          className={classNames('button button-outline-primary button-lg')}
          onClick={handleActionButtonClick}
        >
          Visit Project Page
        </a>
        <a
          href={appLink}
          target="_blank"
          rel="noreferrer"
          onClick={handleActionButtonClick}
          className={classNames('button button-solid-secondary button-lg', {
            'button-disabled pointer-events-none': countdownDate > 0,
          })}
          data-qa="vote-continue-button"
        >
          {countdownDate > 0 && (
            <>
              Verify{' '}
              <Countdown
                date={countdownDate}
                onComplete={handleCountdownComplete}
                renderer={({ seconds }: CountdownRenderProps) => seconds}
              />{' '}
              sec
            </>
          )}

          {countdownDate <= 0 && <>Continue on Voting</>}
        </a>
      </div>
    </>
  );
};

export default BeforeVoteStep;
